/* eslint-disable */
/* fichier a reecrire */
import * as tabPanelStyles from '../../styles/admissions/admissions.module.scss';
import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';

import CkEditor from './ckeditor/CkEditor';
import clsx from 'clsx';
import { useLocation } from '@reach/router';
import _ from 'lodash';
import * as classesTabPanel from '../../styles/communs/tab-panel.module.scss';
import slugify from 'slugify';

import Anchor from '../shared/Anchor';
import Button from './Button';
import { useEffect } from 'react';

const toHash = (str) => {
  if (str && str.charAt(0) !== '#') {
    str = '#' + str;
  }
  return str;
};

const toId = (tab) => {
  let str = '';

  if (tab.anchor) {
    str = tab.anchor;
  } else {
    str = slugify(tab.title || 'undefined');
  }

  if (str && str.charAt(0) === '#') {
    return str.slice(1);
  }
  return str;
};

const toButtonId = (tab) => {
  let str = '';

  if (tab.anchor) {
    str = tab.anchor;
  } else {
    str = slugify(tab.title || 'undefined');
  }
  return `tab-${str}`;
};

const TabPanel = ({elem}) => {
  const location = useLocation();
  const tabs = elem.TabPanel;
  const hashIndex = useMemo(() => {
    const h = {};
    tabs.forEach((tab, ix) => {
      if (tab.anchor) {
        h[toHash(tab.anchor)] = ix;
      }
    });
    return h;
  }, [tabs]);

    //const idx = location.hash ? hashIndex[location.hash] : 0;
    let idx = 0
    const [selectedTab, setSelectedTab] = useState(idx);
    /*
                useEffect(()=> {
                  setSelectedTab(idx)
                }, [idx])
              */

    useEffect(() => {
        if (location && location.hash) {
            let lidx =  hashIndex[location.hash] || 0
            setSelectedTab(lidx)
        }
    }, [location, hashIndex])

    let clickEventListener = null;
    let keydownEventListener = null;
    let keyupEventListener = null;

  function clickEventHandler (event) {

    if (typeof window !== 'undefined' && clickEventListener) {
      return clickEventListener(event);
    }
  }

  function keydownEventHandler (event) {
    if (typeof window !== 'undefined' && keydownEventListener) {
      return keydownEventListener(event);
    }
  }

  function keyupEventHandler (event) {
    if (typeof window !== 'undefined' && keyupEventListener) {
      return keyupEventListener(event);
    }
  }

  if (typeof window !== 'undefined') {
    const ally_tablist = document.querySelectorAll('[role="tablist"]')[0];

    let ally_tabs;
    let ally_panels;

    generateArrays();

    function generateArrays () {
      ally_tabs = document.querySelectorAll('[role="tab"]');
      ally_panels = document.querySelectorAll('[role="tabpanel"]');
    }

    const keys = {
      end: 35, home: 36, left: 37, up: 38, right: 39, down: 40, delete: 46, enter: 13, space: 32,
    };

    const direction = {
      37: -1, 38: -1, 39: 1, 40: 1,
    };

    for (let i = 0; i < ally_tabs.length; ++i) {
      addListeners(i);
    }

    function addListeners (index) {
      /*
                ally_tabs[index].addEventListener("click", clickEventListener);
                ally_tabs[index].addEventListener("keydown", keydownEventListener);
                ally_tabs[index].addEventListener("keyup", keyupEventListener);
            */

      ally_tabs[index].index = index;
    }

    clickEventListener = (event) => {
      const tab = event.currentTarget;

      activateTab(tab, false);
    };

    keydownEventListener = (event) => {
      const key = event.keyCode;

      switch (key) {
      case keys.end:
        event.preventDefault();
        focusLastTab();
        break;
      case keys.home:
        event.preventDefault();
        focusFirstTab();
        break;

      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
      default:
        break;
      }
    };

    keyupEventListener = (event) => {
      const key = event.keyCode;

      switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;

      case keys.enter:
      case keys.space:
        activateTab(event.target);
        break;
      default:
        break;
      }
    };

    function determineOrientation (event) {
      const key = event.keyCode;
      const vertical = (ally_tablist.getAttribute('aria-orientation') === 'vertical');

      let proceed = false;

      if (vertical) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else {
        if (key === keys.left || key === keys.right) {
          proceed = true;
        }
      }

      if (proceed) {
        switchTabOnArrowPress(event);
      }
    }

    function switchTabOnArrowPress (event) {
      const pressed = event.keyCode;

      if (direction[pressed]) {
        const target = event.target;

        if (target.index !== undefined) {
          if (ally_tabs[target.index + direction[pressed]]) {
            ally_tabs[target.index + direction[pressed]].focus();
          } else if (pressed === keys.left || pressed === keys.up) {
            focusLastTab();
          } else if (pressed === keys.right || pressed === keys.down) {
            focusFirstTab();
          }
        }
      }
    }

    function activateTab (tab, setFocus) {
      setFocus = setFocus || true;

      deactivateTabs();

      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', 'true');

      const controls = tab.getAttribute('aria-controls');

      let currentTab = _.findIndex(tabs, ['anchor', controls]);

      if (currentTab === -1) {
        currentTab = _.findIndex(tabs, (t) => {
          return slugify(t.title || 'undefined') === controls;
        });
      }

      setSelectedTab(currentTab);
      document.getElementById(controls).classList.remove('is-hidden');

      if (setFocus) {
        tab.focus();
      }
    }

    function deactivateTabs () {
      for (let t = 0; t < ally_tabs.length; t++) {
        ally_tabs[t].setAttribute('tabindex', -1);
        ally_tabs[t].setAttribute('aria-selected', 'false');
      }

      for (let p = 0; p < ally_panels.length; p++) {
        ally_panels[p].classList.add('is-hidden');
      }
    }

    function focusFirstTab () {
      ally_tabs[0].focus();
    }

    function focusLastTab () {
      ally_tabs[ally_tabs.length - 1].focus();
    }
  }

  const header = () => {
    return (
      <div
        className={tabPanelStyles.root}
      >
        <div
          aria-label="Actions"
          className={tabPanelStyles.tabPanel}
          role="tablist"
        >
          {tabs?.map((tab, index) => (
            <div
              className={tabPanelStyles.containerMapTab}
              key={index}
            >
              <div className={tabPanelStyles.containerButton}>
                <Button
                  dataCy={`tabpanel-button-${index}`}
                  key={index}
                  role="tab"
                  aria-selected={index === selectedTab ? "true" : "false"}
                  aria-controls={toId(tab)}
                  id={toButtonId(tab)}
                  tabIndex={index === selectedTab ? 0 : -1}
                  className={clsx({[tabPanelStyles.clickedTab]: selectedTab === index, [tabPanelStyles.notClickedTab]: selectedTab !== index})}
                  style={selectedTab === index ? {borderRadius: 7, backgroundColor: "var(--red-color)"} : {}}
                  onClick={clickEventHandler}
                  onKeyDown={keydownEventHandler}
                  onKeyUp={keyupEventHandler}
                >
                  <h2
                    className={clsx({
                        [classesTabPanel.title]: selectedTab !== index,
                        [classesTabPanel.titleSelected]: selectedTab === index
                    })}
                  >
                    {tab.title}
                  </h2>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>);
    };

    const panels = () => {
      return (<>
        {tabs.map((tab, idx) => (
          <div
            data-cy={`tabpanel-${idx}`}
            className={clsx(tabPanelStyles.contentPanel, {[classesTabPanel.inactive]: idx !== selectedTab})}
            key={idx}
            role="tabpanel"
            id={toId(tab)}
            aria-labelledby={toButtonId(tab)}
          >
            <Anchor anchor={toHash(tab.anchor)}/>
            <CkEditor html={tab.content} key={tab.content}/>
          </div>
        ))}
      </>);
    };

  return (
    <>
      {header()}
      {panels()}
    </>
  );
};

TabPanel.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      anchor: PropTypes.string,
      content: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TabPanel;
